import React, { Component } from "react";
import styles from './styles.module.scss'


import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,

} from "recharts";

import cx from 'classnames';

import buildUrl from "build-url-ts";
import _ from "lodash";
import moment from 'moment';
import numeral from "numeral";

import InfiniteScroll from "react-infinite-scroller";
import { localizedStrings } from 'src/localization/index.jsx';
import EmptyGraph from 'src/legacy/images/emptyGraph.png'
import TimeLineView from "./dealTimeLine/view";
import BackButton from "src/components/backButton";

export default class DealDetailsView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      hideDropDown: false
    }
    this.handleHideDropdown = this.handleHideDropdown.bind(this);

    this.localizedDealinsights = localizedStrings.pages.dealInsights;
    this.localizedCommons = localizedStrings.commons;
  }

  componentWillMount() {
    this.props.fetchDeal(_.get(this.props, "params.id"));
  }

  componentDidMount() {
    if (_.get(this.props, "params.id")) {
      this.props.fetchDealInsightsSignals(_.get(this.props, "params.id"), 0);
      this.props.fetchDealHistory(_.get(this.props, "params.id"), { page: 0, limit: 300 });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.deal, nextProps.deal)) {
      this.props.fetchDealInsightsSignals(_.get(nextProps, "params.id"), 0);
      this.props.fetchDealHistory(_.get(nextProps, "params.id"), { page: 0, limit: 300 });
    }
  }

  componentWillUnmount() {
    this.props.invalidateDeal();
  }

  handleHideDropdown() {
    this.setState({ hideDropDown: true })
  }

  render() {
    return (
      <div onClick={this.handleHideDropdown} className={styles.mainContainer}>
        {this.props.deal && <DealContent navigate={this.props.navigate} isHistoryFetching={this.props.isHistoryFetching} params={this.props.params} deal={this.props.deal} invalidateDealInsightsSignals={this.props.invalidateDealInsightsSignals} fetchDealInsightsSignals={this.props.fetchDealInsightsSignals} signals={this.props.signals} history={this.props.history} hideDropDown={this.state.hideDropDown} primaryColor={this.props.primaryColor} />}
        {this.props.deal && <TimeLineView params={this.props.params} deal={this.props.deal} timeline={this.props.timeline} assets={this.props.assets} collections={this.props.collections} />}
      </div>
    );
  }

}

class DealContent extends Component {
  constructor(props) {
    super(props);
    this.state = {

      showWonDistribution: true,
      showLostDistribution: false,
      showDropdown: false,
      isCounterHovered: false
    }

    this.renderAnalytics = this.renderAnalytics.bind(this);
    this.renderAnalyticsFooter = this.renderAnalyticsFooter.bind(this);
    this.renderFooterContents = this.renderFooterContents.bind(this);

    this.localizedDealinsights = localizedStrings.pages.dealInsights;
    this.localizedCommons = localizedStrings.commons;

  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.hideDropDown) {
      this.setState({
        showDropdown: false,
        isCounterHovered: false
      })
    }
  }

  componentWillUnmount() {
    this.props.invalidateDealInsightsSignals();
  }

  renderLastActivityDate() {

    if (this.props.deal.lastActivityDate) {

      return (
        <div className={styles.footerContent}>
          <i className="paperflite-clock" />
          <span> {this.localizedDealinsights.deal_details.graph.last_activity} {moment(this.props.deal.lastActivityDate).format("DD MMM YYYY")} </span>
        </div>
      )

    }

  }

  renderCreatedDate() {

    if (this.props.deal.createdDate) {

      return (
        <div className={styles.footerContent}>
          <i className="paperflite-calendar" />
          <span>{this.localizedCommons.created} {moment(this.props.deal.createdDate).format("DD MMM YYYY")} </span>
        </div>
      );

    }

  }

  renderOwner() {

    if (this.props.deal.owner) {

      return (
        <div className={styles.footerContent}>
          <i className="paperflite-user-settings" />
          <span> {this.localizedCommons.created_by} {this.props.deal.owner} </span>
        </div>
      );

    }

  }

  renderFooterContents() {
    return (

      <div className={styles.footerContentContainer}>

        {this.renderLastActivityDate()}
        {this.renderCreatedDate()}
        {this.renderOwner()}

      </div>
    )

  }

  renderAnalyticsFooter() {
    return (
      <div className={styles.analyticsFooterContainer}>
        {this.renderFooterContents()}
      </div>
    )

  }

  renderAnalytics() {

    return (
      <div className={styles.analyticsContainer}>

        {this.props.isHistoryFetching && <div className={styles.loadingMessageContainer}><p> {this.localizedCommons.loading.loading}... </p></div>}

        {_.size(this.props.history) > 0 && !this.props.isHistoryFetching && <div className={styles.graphContainer}>

          <ResponsiveContainer>

            <AreaChart data={this.props.history}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={this.props.primaryColor} stopOpacity={0.2} />
                  <stop offset="95%" stopColor={this.props.primaryColor} stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis axisLine={false} dataKey="createdDateStr" dy={15} />
              <YAxis axisLine={false} dataKey="aiConfidence" dx={-15} label={{ value: this.localizedDealinsights.deal_details.graph.ai_probability, angle: -90, position: 'insideLeft', fontSize: 12 }} />
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <Tooltip
                wrapperStyle={{ outlineColor: this.props.primaryColor }}
                content={<TimeLineChartCustomToolTip tooltip={"Streams Created"} />}
              />
              <Area type="monotone" dataKey="aiConfidence" strokeWidth={3} stroke={this.props.primaryColor} fillOpacity={1} fill="url(#colorUv)" />
            </AreaChart>

          </ResponsiveContainer>

        </div>}

        {_.size(this.props.history) === 0 && !this.props.isHistoryFetching && <div className={styles.emptyGraphContainer}><img src={EmptyGraph} alt="empty graph" /></div>}

        {!this.props.isHistoryFetching && <div className={styles.cardsContainer}>
          <div className={styles.card}>
            <div className={styles.title}>
              <h3>
                {
                  _.get(this.props, "deal.value", 0) >= 0 ?
                    `$${_.round(_.get(this.props, "deal.value", 0))}` :
                    `-$${Math.abs(_.round(_.get(this.props, "deal.value", 0)))}`
                }
              </h3>
              <p>{this.localizedDealinsights.deal_details.card.total_revenues}</p>
            </div>

          </div>

          <div className={styles.card}>
            <div className={styles.title}>
              <h3>{this.props.deal.remainingDays}</h3>
              <p>{this.localizedDealinsights.deal_details.card.days_remaining}
                <span className={styles.subText}> {_.get(this.props.deal, "expectedCloseDate", false) ? <span> &nbsp; ({moment(_.get(this.props.deal, "expectedCloseDate")).format("DD MMM YYYY")})</span> : this.localizedDealinsights.deal_details.card.invalid_date}
                </span>
              </p>
            </div>

          </div>

        </div>}

      </div>
    )
  }

  handleClick(value) {
    {
      this.setState({
        showWonDistribution: value === "won",
        showLostDistribution: value === "lost"
      })
    }
  }

  renderInfographicView() {

    return (
      <div className={styles.infographicContainer}>
        <p className={styles.title}>{this.localizedDealinsights.infographic_view.title}</p>
        <div className={styles.distributionContainer}>
          <button className={cx({
            [styles.active]: this.state.showWonDistribution
          })} onClick={() => this.handleClick("won")}>{this.localizedDealinsights.infographic_view.won} </button>
          <button className={cx({
            [styles.active]: this.state.showLostDistribution
          })} onClick={() => this.handleClick("lost")}> {this.localizedDealinsights.infographic_view.lost}</button>
        </div>
      </div>
    )
  }

  handleURLRedirect() {
    const url = buildUrl(`/settings/integrations?type=crm`)
    this.props.navigate(url);
  }

  handleLoadMore() {
    const currentPage = _.get(this.props, "signals.currentPage", 0);
    const totalPages = _.get(this.props, "signals.totalPages", 0);
    const fetching = _.get(this.props, "signals.fetching", true);
    const nextPage = currentPage + 1;

    if (fetching || nextPage >= totalPages) {
      return;
    }

    this.props.fetchDealInsightsSignals(_.get(this.props, "params.id"), nextPage);
  }

  renderSignalCards() {

    return (
      <div className={styles.signalsContainer}>
        <p className={styles.title}>{this.localizedDealinsights.deal_details.signals_gaps}</p>
        <div className={styles.signalCardsContainer}>
          <InfiniteScroll
            pageStart={0}
            initialLoad={false}
            hasMore={true}
            loadMore={this.handleLoadMore.bind(this)}
            useWindow={false}
            threshold={250}
            className={styles.signalCards}
          >
            {_.get(this.props, "signals.items", []).map((data, index) => (
              <div key={index} className={styles.signalCard}>
                <div className={styles.card}>
                  <h3>{index + 1 < 10 ? `0${index + 1}` : index + 1} </h3>
                  <div className={styles.signalContent}>
                    <p className={styles.signalBody}>
                      {_.get(data, "subject")}
                    </p>
                    <p className={styles.signalValue}>
                      {_.get(data, "message")}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </InfiniteScroll>
        </div>
      </div>

    )

  }


  render() {

    const crmUrl = _.get(this.props.deal, "url", "");
    return (
      <div className={styles.contentContainer} >

        <BackButton onClick={() => this.props.navigate(-1)} className={styles.backButton} />

        <div className={styles.headerContainer}>
          <p className={styles.title}>{_.get(this.props.deal, 'title', '')}</p>
          {_.size(crmUrl) > 0 && <span className={styles.linkContainer}>
            <a href={crmUrl} className={styles.link} target="_blank">
              <span className={styles.iconContainer}>
                <i className="paperflite-arrow-up" />
              </span>
              {this.localizedDealinsights.deal_details.crm_url} </a>
          </span>}
        </div>
        <div>
          {this.renderAnalytics()}
          {this.renderAnalyticsFooter()}
          {_.size(_.get(this.props, "signals.items", [])) > 0 && this.renderSignalCards()}
        </div>
      </div>
    );
  }

}

const TimeLineChartCustomToolTip = ({ tooltip, active, payload, label }) => {

  const localizedDealinsights = localizedStrings.pages.dealInsights;
  if (active && !_.isEmpty(payload)) {
    var item = payload[0].payload;

    var confidence = item.aiConfidence;
    if (!_.isNull(confidence) && !_.isUndefined(confidence) && _.isNumber(confidence) && !_.isInteger(confidence)) {
      confidence = confidence.toFixed(2);
    }

    return (
      <div className={styles.tooltipBox}>
        <p className={styles.tootltipTitle}>{item.stageValue} </p>
        <div className={styles.tooltipBody}>
          <div className={styles.probabilityContainer}>
            <p className={styles.tooltipValue}>{_.round(confidence, 0)}%</p>
            <p className={styles.content}>{localizedDealinsights.deal_details.graph.tool_tip.probability}</p>
          </div>
        </div>
        <p className={styles.tooltipDate}>{_.get(item, "createdDateStr")}</p>
      </div>
    );
  }

  return null;
};

